import { Type } from '@angular/core';

/** Тематическая категория примера (для группировки на индексе). */
export type DemoCategory =
  | 'Basics' | 'Columns' | 'Pagination' | 'Sorting'
  | 'Selection' | 'Actions & menu' | 'Filtering' | 'Rows & layout';

/** Порядок вывода категорий на индекс-странице. */
export const DEMO_CATEGORIES: DemoCategory[] = [
  'Basics', 'Columns', 'Pagination', 'Sorting',
  'Selection', 'Actions & menu', 'Filtering', 'Rows & layout',
];

/** Пути к исходникам примера относительно ассета demo-src/. */
export interface DemoSources {
  /** .ts — есть всегда. */
  ts: string;
  /** .html — когда компонент использует templateUrl. */
  html?: string;
  /** .scss — есть не у всех примеров. */
  scss?: string;
}

/** Одна запись каталога демо. */
export interface DemoEntry {
  /** URL-slug (уникальный), сегмент /demo/<slug>. */
  slug: string;
  /** Заголовок страницы и пункта индекса. */
  title: string;
  /** Одна строка: что демонстрирует пример. */
  description: string;
  category: DemoCategory;
  /** Компонент, рендерящийся в router-outlet страницы. */
  component: Type<unknown>;
  sources: DemoSources;
}
